module.exports = __webpack_public_path__ + "public/3d536f380466c415ea74e04b54dcc087.svg";